import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/at.svg'


const _withScopeId = n => (_pushScopeId("data-v-11f884e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TUIChat-header" }
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = { class: "TUIChat-main" }
const _hoisted_4 = { class: "TUIChat-safe-tips" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "dialog-item" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-copy" }, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-copy" }, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-forward" }, null, -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-quote" }, null, -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-revoke" }, null, -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-del" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-bottom-double" }, null, -1))
const _hoisted_20 = { class: "to-bottom-tip-cont" }
const _hoisted_21 = {
  key: 0,
  class: "dialog dialog-conversation"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "name" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 0,
  class: "name"
}
const _hoisted_26 = {
  key: 1,
  class: "dialog dialog-conversation"
}
const _hoisted_27 = {
  class: "func",
  id: "func"
}
const _hoisted_28 = { class: "func-main" }
const _hoisted_29 = {
  key: 0,
  class: "memberList"
}
const _hoisted_30 = {
  class: "memberList-box",
  ref: "dialog"
}
const _hoisted_31 = {
  key: 0,
  class: "memberList-box-title"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "选择提醒的人", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "reference" }
const _hoisted_37 = {
  key: 0,
  class: "reference-box"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_39 = { class: "reference-box-show" }
const _hoisted_40 = { class: "input" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "input-btn-hover" }
const _hoisted_45 = { class: "mask-main" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "TUIChat"
}
const _hoisted_48 = { class: "TUIChat-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_typing_header = _resolveComponent("typing-header")!
  const _component_Manage = _resolveComponent("Manage")!
  const _component_MessageTip = _resolveComponent("MessageTip")!
  const _component_MessageText = _resolveComponent("MessageText")!
  const _component_MessageImage = _resolveComponent("MessageImage")!
  const _component_MessageVideo = _resolveComponent("MessageVideo")!
  const _component_MessageAudio = _resolveComponent("MessageAudio")!
  const _component_MessageFile = _resolveComponent("MessageFile")!
  const _component_MessageFace = _resolveComponent("MessageFace")!
  const _component_MessageLocation = _resolveComponent("MessageLocation")!
  const _component_MessageCustom = _resolveComponent("MessageCustom")!
  const _component_MessageMerger = _resolveComponent("MessageMerger")!
  const _component_MessageBubble = _resolveComponent("MessageBubble")!
  const _component_MessageRevoked = _resolveComponent("MessageRevoked")!
  const _component_ReadReceiptDialog = _resolveComponent("ReadReceiptDialog")!
  const _component_MessageSystem = _resolveComponent("MessageSystem")!

  return (_ctx.conversationType === 'chat')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["TUIChat", [_ctx.env.isH5 ? 'TUIChat-H5' : '']])
      }, [
        _createElementVNode("header", _hoisted_1, [
          (_ctx.env.isH5)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon icon-back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_typing_header, {
            needTyping: _ctx.needTyping,
            conversation: _ctx.conversation,
            messageList: _ctx.messageList,
            inputText: _ctx.text,
            inputBlur: _ctx.inputBlur,
            inputCompositionCont: _ctx.inputCompositionCont
          }, null, 8, ["needTyping", "conversation", "messageList", "inputText", "inputBlur", "inputCompositionCont"]),
          _createElementVNode("aside", _hoisted_2, [
            (_ctx.conversation.groupProfile)
              ? (_openBlock(), _createBlock(_component_Manage, {
                  key: 0,
                  conversation: _ctx.conversation,
                  userInfo: _ctx.userInfo,
                  isH5: _ctx.env.isH5
                }, null, 8, ["conversation", "userInfo", "isH5"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.安全提示')), 1)
          ]),
          _createElementVNode("ul", {
            class: _normalizeClass(['TUI-message-list']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogID = '')),
            ref: "messageEle",
            id: "messageEle"
          }, [
            (!_ctx.isCompleted)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "message-more",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getHistoryMessageList && _ctx.getHistoryMessageList(...args)))
                }, _toDisplayString(_ctx.$t('TUIChat.查看更多')), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                id: item?.ID,
                ref_for: true,
                ref: "messageAimID"
              }, [
                (_ctx.isMessageTip(item))
                  ? (_openBlock(), _createBlock(_component_MessageTip, {
                      key: 0,
                      data: _ctx.handleTipMessageShowContext(item)
                    }, null, 8, ["data"]))
                  : (!item.isRevoked)
                    ? (_openBlock(), _createBlock(_component_MessageBubble, {
                        key: 1,
                        isH5: _ctx.env.isH5,
                        data: item,
                        messagesList: _ctx.messages,
                        needGroupReceipt: _ctx.needGroupReceipt,
                        onJumpID: _ctx.jumpID,
                        onResendMessage: _ctx.resendMessage,
                        onShowReadReceiptDialog: _ctx.showReadReceiptDialog,
                        onDropDownOpen: _ctx.handleDropDownOpen
                      }, {
                        dialog: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_6, [
                            (
                    (item.type === _ctx.types.MSG_FILE ||
                      item.type === _ctx.types.MSG_VIDEO ||
                      item.type === _ctx.types.MSG_IMAGE) &&
                    !_ctx.env.isH5
                  )
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.openMessage(item))
                                }, [
                                  _hoisted_8,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.打开')), 1)
                                ], 8, _hoisted_7))
                              : _createCommentVNode("", true),
                            (item.type === _ctx.types.MSG_TEXT)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.handleMseeage(item, _ctx.constant.handleMessage.copy))
                                }, [
                                  _hoisted_10,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.复制')), 1)
                                ], 8, _hoisted_9))
                              : _createCommentVNode("", true),
                            (item.status === 'success')
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 2,
                                  onClick: ($event: any) => (_ctx.handleMseeage(item, _ctx.constant.handleMessage.forward))
                                }, [
                                  _hoisted_12,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.转发')), 1)
                                ], 8, _hoisted_11))
                              : _createCommentVNode("", true),
                            (item.status === 'success')
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 3,
                                  onClick: ($event: any) => (_ctx.handleMseeage(item, 'reply'))
                                }, [
                                  _hoisted_14,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.引用')), 1)
                                ], 8, _hoisted_13))
                              : _createCommentVNode("", true),
                            (item.flow === 'out' && item.status === 'success')
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 4,
                                  onClick: ($event: any) => (_ctx.handleMseeage(item, _ctx.constant.handleMessage.revoke))
                                }, [
                                  _hoisted_16,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.撤回')), 1)
                                ], 8, _hoisted_15))
                              : _createCommentVNode("", true),
                            (item.status === 'success')
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 5,
                                  onClick: ($event: any) => (_ctx.handleMseeage(item, _ctx.constant.handleMessage.delete))
                                }, [
                                  _hoisted_18,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('TUIChat.删除')), 1)
                                ], 8, _hoisted_17))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx(() => [
                          (item.type === _ctx.types.MSG_TEXT)
                            ? (_openBlock(), _createBlock(_component_MessageText, {
                                key: 0,
                                data: _ctx.handleTextMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_IMAGE)
                            ? (_openBlock(), _createBlock(_component_MessageImage, {
                                key: 1,
                                data: _ctx.handleImageMessageShowContext(item),
                                isH5: _ctx.env.isH5
                              }, null, 8, ["data", "isH5"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_VIDEO)
                            ? (_openBlock(), _createBlock(_component_MessageVideo, {
                                key: 2,
                                data: _ctx.handleVideoMessageShowContext(item),
                                isH5: _ctx.env.isH5
                              }, null, 8, ["data", "isH5"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_AUDIO)
                            ? (_openBlock(), _createBlock(_component_MessageAudio, {
                                key: 3,
                                data: _ctx.handleAudioMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_FILE)
                            ? (_openBlock(), _createBlock(_component_MessageFile, {
                                key: 4,
                                data: _ctx.handleFileMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_FACE)
                            ? (_openBlock(), _createBlock(_component_MessageFace, {
                                key: 5,
                                data: _ctx.handleFaceMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_LOCATION)
                            ? (_openBlock(), _createBlock(_component_MessageLocation, {
                                key: 6,
                                data: _ctx.handleLocationMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_CUSTOM)
                            ? (_openBlock(), _createBlock(_component_MessageCustom, {
                                key: 7,
                                data: _ctx.handleCustomMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (item.type === _ctx.types.MSG_MERGER)
                            ? (_openBlock(), _createBlock(_component_MessageMerger, {
                                key: 8,
                                data: _ctx.handleMergerMessageShowContext(item)
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["isH5", "data", "messagesList", "needGroupReceipt", "onJumpID", "onResendMessage", "onShowReadReceiptDialog", "onDropDownOpen"]))
                    : (_openBlock(), _createBlock(_component_MessageRevoked, {
                        key: 2,
                        isEdit: item.type === _ctx.types.MSG_TEXT,
                        data: item,
                        onEdit: ($event: any) => (_ctx.handleEdit(item))
                      }, null, 8, ["isEdit", "data", "onEdit"]))
              ], 8, _hoisted_5))
            }), 128)),
            (_ctx.needToBottom)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "to-bottom-tip",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToTarget('bottom')))
                }, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.toBottomTipCont), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512),
          (_ctx.forwardStatus && _ctx.messageComponents.Forward)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_openBlock(), _createBlock(_resolveDynamicComponent('Forward'), {
                  list: _ctx.conversationData.list,
                  message: _ctx.currentMessage,
                  show: _ctx.forwardStatus,
                  isH5: _ctx.env.isH5,
                  "onUpdate:show": _cache[4] || (_cache[4] = (e) => (_ctx.forwardStatus = e))
                }, {
                  left: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.conversationData.handleAvatar(data)
                    }, null, 8, _hoisted_22),
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.conversationData.handleName(data)), 1)
                  ]),
                  right: _withCtx(({ data }) => [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.conversationData.handleAvatar(data)
                    }, null, 8, _hoisted_24),
                    (!_ctx.env.isH5)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString(_ctx.conversationData.handleName(data)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 40, ["list", "message", "show", "isH5"]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.needGroupReceipt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_ReadReceiptDialog, {
                  message: _ctx.currentMessage,
                  conversation: _ctx.conversation,
                  show: _ctx.receiptDialogStatus,
                  isH5: _ctx.env.isH5,
                  onCloseDialog: _ctx.closeReadReceiptDialog,
                  ref: "readReceiptDialog"
                }, null, 8, ["message", "conversation", "show", "isH5", "onCloseDialog"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["TUIChat-footer", [_ctx.isMute && 'disabled', _ctx.env.isH5 && 'TUIChat-H5-footer']])
        }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("main", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pluginComponentList, (item, index) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
                  key: index,
                  isMute: _ctx.isMute,
                  isH5: _ctx.env.isH5,
                  conversation: _ctx.conversation,
                  parentID: "func",
                  onSend: _ctx.handleSend
                }, null, 40, ["isMute", "isH5", "conversation", "onSend"]))
              }), 128))
            ])
          ]),
          (_ctx.showGroupMemberList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("ul", _hoisted_30, [
                  (_ctx.env.isH5)
                    ? (_openBlock(), _createElementBlock("header", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("span", {
                          class: "close",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleshowGroupMemberList && _ctx.toggleshowGroupMemberList(...args)))
                        }, "关闭")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", {
                    class: "memberList-box-header",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectAt('allMember', _ctx.allMember)))
                  }, [
                    _hoisted_33,
                    _createElementVNode("span", null, _toDisplayString(_ctx.allMember[0].allText), 1),
                    _createElementVNode("span", null, "(" + _toDisplayString(_ctx.allMemberList.length) + ")", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allMemberList, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "memberList-box-body",
                      key: index,
                      onClick: ($event: any) => (_ctx.selectAt('oneMember', item))
                    }, [
                      _createElementVNode("img", {
                        src: item.avatar,
                        alt: ""
                      }, null, 8, _hoisted_35),
                      _createElementVNode("span", null, _toDisplayString(item.nick ? item.nick : item.userID), 1)
                    ], 8, _hoisted_34))
                  }), 128))
                ], 512)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            (_ctx.showReference)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.referenceMessage.nick
                ? _ctx.referenceMessage.nick
                : _ctx.referenceMessage.from), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.referenceMessageForShow), 1)
                  ]),
                  _createElementVNode("label", {
                    class: "icon icon-cancel",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showReference = false))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _withDirectives(_createElementVNode("textarea", {
              ref: "inputEle",
              onPaste: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.pasting && _ctx.pasting(...args))),
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.text) = $event)),
              placeholder: _ctx.$t('TUIChat.请输入消息'),
              "data-type": "text",
              onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.inputChange && _ctx.inputChange(...args))),
              onKeyup: [
                _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMseeage && _ctx.sendMseeage(...args)), ["enter"])),
                _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.deleteAt && _ctx.deleteAt(...args)), ["delete"]))
              ],
              onKeypress: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.geeks && _ctx.geeks(...args))),
              onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.inputBlur = true)),
              onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.inputBlur = false)),
              onCompositionstart: _cache[16] || (_cache[16] = ($event: any) => (_ctx.inputComposition = true)),
              onCompositionend: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.compositionEnd && _ctx.compositionEnd(...args))),
              rows: "1"
            }, null, 40, _hoisted_41), [
              [_vModelText, _ctx.text]
            ]),
            (_ctx.isMute)
              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.$t(`TUIChat.${_ctx.muteText}`)), 1))
              : _createCommentVNode("", true),
            (!_ctx.isMute)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "input-btn",
                  "data-type": "text",
                  disabled: !_ctx.text,
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.sendMseeage && _ctx.sendMseeage(...args)))
                }, [
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('TUIChat.按Enter发送，Ctrl+Enter换行')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('发送')), 1)
                ], 8, _hoisted_43))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", {
          class: "mask",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showResend = false))
        }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("header", null, _toDisplayString(_ctx.$t('TUIChat.确认重发该消息？')), 1),
            _createElementVNode("footer", null, [
              _createElementVNode("p", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showResend = false))
              }, _toDisplayString(_ctx.$t('TUIChat.取消')), 1),
              _hoisted_46,
              _createElementVNode("p", {
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, _toDisplayString(_ctx.$t('TUIChat.确定')), 1)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showResend]
        ])
      ], 2))
    : (_ctx.conversationType === 'system')
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("header", _hoisted_48, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.conversationName), 1)
          ]),
          _createVNode(_component_MessageSystem, {
            data: _ctx.messages,
            types: _ctx.types,
            onApplication: _ctx.handleApplication
          }, null, 8, ["data", "types", "onApplication"])
        ]))
      : (_ctx.slotDefault)
        ? _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
        : _createCommentVNode("", true)
}